import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';

import { CitizenComponent } from './citizen.component';
import { CitizenSelectFormComponent } from './citizen-select-form/citizen-select-form.component';
import { CitizenDataListComponent } from './citizen-data-list/citizen-data-list.component';
import { CitizenPartitionChartComponent } from './citizen-partition-chart/citizen-partition-chart.component';
import { CitizenReportChartComponent } from './citizen-report-chart/citizen-report-chart.component';

@NgModule({
  declarations: [
      CitizenComponent,
      CitizenSelectFormComponent,
      CitizenDataListComponent,
      CitizenPartitionChartComponent,
      CitizenReportChartComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class CitizenModule { }
